import _get from 'lodash/get';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var getSourceCodeOptionLabel = function getSourceCodeOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var _option$data = option.data,
    data = _option$data === void 0 ? EMPTY_OBJECT : _option$data;
  return "".concat(data.code, " - ").concat(data.description);
};
var getSourceCodeOptionValue = function getSourceCodeOptionValue() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return _get(option, 'data.id');
};
var PART_SOURCE_CODE_CONFIG = {
  getOptionLabel: getSourceCodeOptionLabel,
  getOptionValue: getSourceCodeOptionValue
};
export default PART_SOURCE_CODE_CONFIG;